<template>
  <form @submit.prevent="submit">
    <b-row>
      <!--Column 1-->
      <b-col sm="4">
        <b-form-group label="Planta">
          <b-form-select
            id="plant"
            :state="
              $v.processData.plant.$dirty ? !$v.processData.plant.$error : null
            "
            v-model="$v.processData.plant.$model"
            :options="plants"
          />
        </b-form-group>
        <b-form-group label="Sala/Línea">
          <b-form-select
            id="process_room"
            :state="
              $v.processData.process_room.$dirty
                ? !$v.processData.process_room.$error
                : null
            "
            v-model="$v.processData.process_room.$model"
            :options="filteredProcessRooms"
          />
        </b-form-group>
      </b-col>

      <!--Column 2-->
      <b-col sm="4">
        <b-form-group label="Turno">
          <b-form-select
            id="shift"
            :state="
              $v.processData.shift.$dirty ? !$v.processData.shift.$error : null
            "
            v-model="$v.processData.shift.$model"
            :options="shifts"
          />
        </b-form-group>

        <b-form-group label="Supervisor">
          <b-form-select
            id="supervisor"
            :state="
              $v.processData.shift_supervisor.$dirty
                ? !$v.processData.shift_supervisor.$error
                : null
            "
            v-model="$v.processData.shift_supervisor.$model"
            :options="supervisors"
          />
        </b-form-group>
      </b-col>

      <!--Column 3 -->
      <b-col sm="4">
        <b-form-group>
          <label for="shift_workers">Personal</label>
          <b-form-input
            type="number"
            :state="
              $v.processData.shift_workers.$dirty
                ? !$v.processData.shift_workers.$error
                : null
            "
            v-model="$v.processData.shift_workers.$model"
            id="shift_workers"
            placeholder="Número de personas trabajando en el turno"
          ></b-form-input>
          <b-form-invalid-feedback id="shift_workers">
            Este campo admite sólo números enteros.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group>
          <label for="start_time">Hora de inicio</label>
          <datetime
            type="datetime"
            :state="
              $v.processData.start_time.$dirty
                ? !$v.processData.start_time.$error
                : null
            "
            v-model="$v.processData.start_time.$model"
            :minute-step="10"
            input-class="form-control"
            class="theme-orange"
          >
          </datetime>
        </b-form-group>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import {
  required,
  numeric,
  minLength,
  between
} from "vuelidate/lib/validators";

export default {
  name: "ProcessForm2",
  components: {},
  props: {
    plants: {
      type: Array,
      default: () => []
    },
    supervisors: {
      type: Array,
      default: () => []
    },
    shifts: {
      type: Array,
      default: () => []
    },
    processData: {
      type: Object
    },
    selectedSala: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      process_rooms: []
    };
  },
  validations: {
    processData: {
      shift_workers: {},
      shift: { required },
      shift_supervisor: { required },
      start_time: { required },
      process_room: { required },
      plant: { required }
    }
  },
  computed: {
    plant() {
      return this.processData.plant;
    },
    filteredProcessRooms() {
      // All process rooms that starts with the selected sala
      console.log(this.selectedSala);
      if (!this.processData.plant) {
        console.log("No plant selected");
        return [];
      } else if (!this.selectedSala) {
        console.log("No sala selected");
        return this.process_rooms;
      } else {
        return this.process_rooms.filter((room) =>
          room.text.startsWith(this.selectedSala)
        );
      }
    }
  },
  watch: {
    plant: {
      handler(val) {
        this.process_room = null;
        this.getProcessRooms(this.plant.id);
        this.$emit("plant", this.plant);
      }
    }
  },
  methods: {
    getProcessRooms(a) {
      this.$axios
        .get("/production/get_plant_process_rooms/" + a)
        .then((res) => {
          this.process_rooms = res.data.process_rooms;
        })
        .catch((error) => console.log(error));
    },

    // Validation methods
    status(validation) {
      return {
        error: validation.$error,
        dirty: validation.$dirty
      };
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$emit("validate", false);
      } else {
        // do your submit logic here
        this.$emit("validate", true);
      }
    }
  }
};
</script>

<style>
.theme-orange .vdatetime-popup__header,
.theme-orange .vdatetime-calendar__month__day--selected > span > span,
.theme-orange .vdatetime-calendar__month__day--selected:hover > span > span {
  background: #20a8d8;
}

.theme-orange .vdatetime-year-picker__item--selected,
.theme-orange .vdatetime-time-picker__item--selected,
.theme-orange .vdatetime-popup__actions__button {
  color: #20a8d8;
}
</style>
